export default "__VITE_ASSET__CWHwTmEJ__"